// extracted by mini-css-extract-plugin
module.exports =  {"root":"Tizl764OPWwEvaoSnfrM","indicator":"GMaGVTGRsQhtBvkzDZjy","indicatorActive":"i_BDLj5bau_yrqYpw_Lq"};